import { render, staticRenderFns } from "./EditPagePlug.vue?vue&type=template&id=1be7bb63"
import script from "./EditPagePlug.vue?vue&type=script&lang=js"
export * from "./EditPagePlug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports